import React, { SyntheticEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Tab,
  Tabs,
} from "@mui/material";

import { GridColDef } from "@mui/x-data-grid";
import SearchBar from "../../components/SearchBar";
import TableComponent from "../../components/TableComponent";
import { isValidInput } from "../../utils/validations";
import useAuth from "../../hooks/useAuth";

import {
  CommonBody,
  PaymentResponseType,
  Permission,
} from "../../types/General";

import {
  useExportPaymentsMutation,
  useGetAllPaymentsMutation,
  usePaymentStatusMutation,
} from "../../service/payments";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { errorToast } from "../../helpers";
import { PAYMENT_STATUS_LABELS, USER_ROLES } from "../../utils/enums";
import moment from "moment";
import { PriceFormatter } from "../../utils/commoFunctions";
import Chip from "../../components/Chip";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Payments = () => {
  const userData = useAuth();
  const [hidePermission, setHidePermission] = useState<Permission>();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");

  const [selectedId, setSelectedId] = useState<number | null>(null);

  const [allPayments] = useGetAllPaymentsMutation();
  const [paymentStatus] = usePaymentStatusMutation();
  const [exportPayments] = useExportPaymentsMutation();

  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState<PaymentResponseType[]>([]);
  const [page, setPage] = useState<number>(1);
  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };
  const [valueTabs, setValueTabs] = useState(0);
  const handleChangeTabs = (event: SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
    setPage(1);
  };

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (
    event: React.MouseEvent<HTMLButtonElement>,
    rowId: number
  ) => {
    setAnchorEl1(event.currentTarget);
    setSelectedId(rowId);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
    setSelectedId(null);
  };

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 200,
      field: "paymentDate",
      headerName: "Payment Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              {row?.created_at
                ? moment(row?.created_at).format("DD MMM YYYY hh:mm a")
                : "-"}
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "applicationId",
      headerName: "Application Id",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.application?.apk_id || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 300,
      field: "applicantDetails",
      headerName: "User Details",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure
              onClick={() => navigate(`/users/individual/${row?.user?.id}`)}
            >
              <img
                src={
                  row?.user?.profile_picture?.media_url ||
                  "/static/images/user_placeholder.png"
                }
                alt=""
              />
            </figure>
            <p>
              <b>{row?.user?.name || "-"}</b> {row?.user?.country_code}{" "}
              {row?.user?.phone_no || ""} <br />
              {row?.user?.email || "-"}
            </p>
          </div>
        );
      },
    },
    // {
    //   flex: 1,
    //   minWidth: 150,
    //   field: "invoiceNumber",
    //   headerName: "Invoice Number",
    //   editable: false,
    //   sortable: false,
    //   renderCell: () => {
    //     return (
    //       <div className="user_block">
    //         <p>WIZ-565744</p>
    //       </div>
    //     );
    //   },
    // },
    {
      flex: 1,
      minWidth: 150,
      field: "paymentMode",
      headerName: "Payment Mode",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.plan_mode?.title || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "paymentType",
      headerName: "Payment Type",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        const partNumber = row?.plan_part_no?.part_number;
        return (
          <div className="user_block">
            <p>
              {partNumber !== null && partNumber !== undefined
                ? PAYMENT_STATUS_LABELS[row?.plan_part_no?.part_number]
                : "-"}
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "amountPaid",
      headerName: "Amount Paid",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              {PriceFormatter(row?.payment_amt_after_vat?.toString()) || "-"}
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "vat",
      headerName: "VAT",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{PriceFormatter(row?.vat?.toString()) || "-"}</p>
          </div>
        );
      },
    },
    // {
    //   flex: 1,
    //   minWidth: 150,
    //   field: "remainingAmount",
    //   headerName: "Remaining Amount",
    //   editable: false,
    //   sortable: false,
    //   renderCell: ({ row }) => {
    //     return (
    //       <div className="user_block">
    //         <p>{PriceFormatter(row?.remaining_amt?.toString()) || "-"}</p>
    //       </div>
    //     );
    //   },
    // },
    ...(valueTabs === 1
      ? [
          {
            flex: 1,
            minWidth: 150,
            field: "receipt",
            headerName: "Receipt",
            editable: false,
            sortable: false,
            renderCell: ({ row }: any) => {
              return (
                <>
                  {row?.payment_slip_partner?.length ? (
                    <Button
                      className="btn btn_blue"
                      onClick={() =>
                        window?.open(row?.payment_slip_partner?.[0]?.media_url)
                      }
                      style={{ height: "30px", padding: "5px 12px" }}
                    >
                      View Receipt
                    </Button>
                  ) : (
                    "-"
                  )}
                </>
              );
            },
          },
          {
            flex: 1,
            minWidth: 150,
            field: "paymentApproval",
            headerName: "Payment Approval",
            editable: false,
            sortable: false,
            renderCell: ({ row }: any) => {
              return (
                <>
                  {row?.is_verified ? (
                    <Chip
                      label={"Approved"}
                      color={"#4CAF50"}
                      backgroundColor={"#E8F5E9"}
                    />
                  ) : (
                    <Button
                      className="btn btn_blue"
                      onClick={() => changePaymentStatus(row?.id)}
                      style={{ height: "30px", padding: "5px 12px" }}
                    >
                      Approve
                    </Button>
                  )}
                </>
              );
            },
          },
        ]
      : []),

    {
      flex: 0.1,
      minWidth: 80,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={(event) => handleClick1(event, row?.id)}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
                    borderRadius: "8px",
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem onClick={() => navigate(`view/${selectedId}`)}>
                  View
                </MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  const getPaymentList = async () => {
    setLoading(true);
    try {
      const body = {
        start: page,
        length: 10,
        search: debouncedSearchTerm.trim(),
        type: valueTabs === 0 ? 2 : 1,
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await allPayments(encryptedBody).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        setRows(response?.data?.response_object || []);
        setCount(response?.data?.total_records);
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  const changePaymentStatus = async (id: number) => {
    setLoading(true);
    try {
      const body = {
        is_verified: true,
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await paymentStatus({
        body: encryptedBody,
        id,
      }).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        getPaymentList();
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };
  const handleExportCSV = async () => {
    setLoading(true);
    try {
      const body = {
        search: debouncedSearchTerm.trim(),
        type: valueTabs === 0 ? 2 : 1,
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await exportPayments(encryptedBody).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        window.open(response?.file_urls, "_blank");
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    getPaymentList();
  }, [debouncedSearchTerm, page, valueTabs]);

  const checkPermission = () => {
    const permission = userData?.role_permission;
    if (permission?.length) {
      const foundPermission = permission?.find(
        (ele: Permission) => ele?.module === "Manage Payments"
      );

      if (foundPermission) {
        setHidePermission(foundPermission);
      } else {
        navigate(-1);
      }
    }
  };

  useEffect(() => {
    if (userData?.user_role_type === USER_ROLES.SUBADMIN) {
      checkPermission();
    }
  }, [userData]);

  useEffect(() => {
    if (typeof hidePermission !== "undefined") {
      if (!hidePermission?.can_view) {
        navigate("/permission-denied", { replace: true });
      }
    }
  }, [hidePermission, userData]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Payments</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          Payments - Payments
        </p>
      </div>
      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <div className="right_s">
              <Box>
                <Button
                  className="btn btn_highlight"
                  onClick={handleExportCSV}
                  disabled={!rows?.length}
                >
                  <img src="/static/images/upload_icon.svg" alt="Icon" /> Export
                  CSV
                </Button>
              </Box>
            </div>
          </div>

          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label={`Online Payments`} {...a11yProps(0)} />
            <Tab label={`Offline Payments`} {...a11yProps(1)} />
          </Tabs>
          <CustomTabPanel value={valueTabs} index={0}>
            <div className="sorting_table">
              <TableComponent
                columns={columns}
                rows={rows}
                count={count}
                page={page}
                onPageChange={handlePageChange}
                loading={loading}
              />
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={1}>
            <div className="sorting_table">
              <TableComponent
                columns={columns}
                rows={rows}
                count={count}
                page={page}
                onPageChange={handlePageChange}
                loading={loading}
              />
            </div>
          </CustomTabPanel>
        </Box>
      </div>
    </MainContainer>
  );
};

export default Payments;
